export default __webpack_public_path__ + "static/media/museum.88bad813.jpg";